import type { ReactNode } from 'react';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import * as scenarioGridSelectors from '@makemydeal/dr-dash-store/selectors/scenarioGridSelectors';

export const OUTSIDE_LIENHOLDER_SUB_ROW_KEYS = ['lienholder', 'address', 'city', 'state', 'zip', 'phone'].map(
    (field) => `outsideLienholder-${field}`
);

export const OUTSIDE_LIENHOLDER_SUB_ROW_COUNT = OUTSIDE_LIENHOLDER_SUB_ROW_KEYS.length;

type OutsideLienholderExpansion = { isExpanded: boolean; toggle: () => void };

const OutsideLienholderExpansionContext = createContext<OutsideLienholderExpansion>({ isExpanded: false, toggle: () => undefined });

export const OutsideLienholderExpansionProvider = ({ children }: { children: ReactNode }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const hasOutsideLienholderRow = useSelector(scenarioGridSelectors.getScenarioRowKeys).includes('outsideLienholder');
    const value = useMemo(() => ({ isExpanded, toggle: () => setIsExpanded((expanded) => !expanded) }), [isExpanded]);

    useEffect(() => {
        if (!hasOutsideLienholderRow) {
            setIsExpanded(false);
        }
    }, [hasOutsideLienholderRow]);

    return <OutsideLienholderExpansionContext.Provider value={value}>{children}</OutsideLienholderExpansionContext.Provider>;
};

export const useOutsideLienholderExpansion = () => useContext(OutsideLienholderExpansionContext);
